export default "__VITE_ASSET__DzkbHuui__"